// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AgeGateController from "./age_gate_controller"
application.register("age-gate", AgeGateController)

import SearchController from "./search_controller"
application.register("search", SearchController)
